export const BASE_API = 'https://premiumapidev.lupuscorner.com/service'; 